module.exports = __webpack_public_path__ + "static/media/calendar.e8d804bf.svg";